import { AuthState } from '@okta/okta-auth-js';

import { FuturesTradeAccountsMassUpdates } from '../../services/backend/FuturesTradeAccountsMassUpdates';
import { useBaseApiClient } from '../useBaseApiClient';

export const useFuturesTradeAccountsMassUpdates: () => FuturesTradeAccountsMassUpdates<AuthState> =
  () => {
    return useBaseApiClient(FuturesTradeAccountsMassUpdates);
  };
